var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.553,
    height: 16.442,
    viewBox: "0 0 20.553 16.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shipping-fast",
    "data-name": "Icon awesome-shipping-fast",
    d: "M20.039,11.3h-.514V7.832a1.541,1.541,0,0,0-.453-1.089L15.864,3.536a1.541,1.541,0,0,0-1.089-.453H13.359V1.541A1.542,1.542,0,0,0,11.818,0H3.6A1.542,1.542,0,0,0,2.055,1.541V3.083H.257A.258.258,0,0,0,0,3.34v.514a.258.258,0,0,0,.257.257H8.992a.258.258,0,0,1,.257.257v.514a.258.258,0,0,1-.257.257H1.285a.258.258,0,0,0-.257.257v.514a.258.258,0,0,0,.257.257h6.68a.258.258,0,0,1,.257.257v.514a.258.258,0,0,1-.257.257H.257A.258.258,0,0,0,0,7.45v.514a.258.258,0,0,0,.257.257h6.68a.258.258,0,0,1,.257.257v.514a.258.258,0,0,1-.257.257H2.055v4.111a3.083,3.083,0,1,0,6.166,0h4.111a3.083,3.083,0,1,0,6.166,0h1.541a.515.515,0,0,0,.514-.514V11.818A.515.515,0,0,0,20.039,11.3Zm-14.9,3.6A1.541,1.541,0,1,1,6.68,13.359,1.542,1.542,0,0,1,5.138,14.9Zm10.276,0a1.541,1.541,0,1,1,1.541-1.541A1.542,1.542,0,0,1,15.414,14.9Zm2.569-6.68H13.359v-3.6h1.416l3.208,3.208Z",
    fill: "#2e117f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.422875e378eccfe0f614584125a6c02b.svg";
export { ForwardRef as ReactComponent };